import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTabActive } from "slices/systemAdmin/systemAdminSlice";
import Switch from "components/Switch";
import AuthenticationUsernamePassword from "layout/systemAdmin/authentication/AuthenticationUsernamePassword";
import AuthenticationSSO from "layout/systemAdmin/authentication/AuthenticationSSO";
import { fetchAuthentication } from "slices/systemAdmin/actions/authentication";
import { clearJobQueue } from "slices/app/appSlice";
import DownloadLogs from "layout/systemAdmin/authentication/DownloadLogs";

const AuthenticationContent = () => {
  const dispatch = useDispatch();
  const usernamePassword = useSelector(
    (state) => state?.systemAdmin.isUsernamePassword
  );
  const [isUsernamePassword, setIsUsernamePassword] =
    useState(usernamePassword);

  const handleSwitch = () => {
    setIsUsernamePassword(!isUsernamePassword);
  };

  useEffect(() => {
    setIsUsernamePassword(usernamePassword);
  }, [usernamePassword]);

  useEffect(() => {
    dispatch(clearJobQueue());
    dispatch(setTabActive(3));
    dispatch(fetchAuthentication());
  }, [dispatch]);

  return (
    <>
      <div className="authentication__content__header">
        <span className={`${isUsernamePassword ? "active" : ""}`}>
          VisibleThread Authentication
        </span>
        <Switch
          handleChange={handleSwitch}
          currentSwitchState={!isUsernamePassword}
          id="authenticationSwitch"
        />
        <span className={`${!isUsernamePassword ? "active" : ""}`}>
          Single Sign-On
        </span>
      </div>
      <div className="authentication__content__body">
        <AuthenticationUsernamePassword enabled={isUsernamePassword} />
        <AuthenticationSSO enabled={!isUsernamePassword} />
      </div>
      <DownloadLogs />
    </>
  );
};

export default AuthenticationContent;
